export default __webpack_public_path__ + "static/media/banner-22.a9dfd131.jpg";